import FormAction from './form_action';

export default class LinkFormAction extends FormAction {
	_url;
	_params;

	constructor(actionProps = {}) {
		super(actionProps);
	}

	get url() {
		return this._url;
	}

	set url(value) {
		this._url = value;
	}

	get params() {
		return this._params;
	}

	set params(value) {
		this._params = value;
	}
}
